export default {
  DANGER_PRIMARY: "DANGER_PRIMARY",
  DANGER_SECONDARY: "DANGER_SECONDARY",
  DANGER_TERTIARY: "DANGER_TERTIARY",
  DARK_PRIMARY: "DARK_PRIMARY",
  DARK_SECONDARY: "DARK_SECONDARY",
  DARK_TERTIARY: "DARK_TERTIARY",
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  TERTIARY: "TERTIARY"
};
